import { render, staticRenderFns } from "./EditField.vue?vue&type=template&id=23ad25a5&"
import script from "./EditField.vue?vue&type=script&lang=ts&"
export * from "./EditField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports